import MigrantsHeader from './components/MigrantsHeader'
import MigrantsBanner from './components/MigrantsBanner'
import MigrantsFooter from './components/MigrantsFooter'
import { useContext, useState } from 'react'
import { AuthContext } from '../../Auth/AuthContext'
import MigrantsVideo from './components/MigrantsVideo'
import MigrantsProcess from './components/process/MigrantsProcess'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'

const DashboardMigrants = () => {
  //------------ Hooks ------------
  const { dispatch, user } = useContext(AuthContext)
  /**
   * Views: 1 = process, 2 = Profile, 3 = process history, 4 = contact
   */
  const [view, setView] = useState(1)

  // const handleClick = (e) => {
  //   toastSweetAlert({
  //     mode: 'ok',
  //     titleMessage: 'Trámite creado',
  //     message: 'Error al crear el trámite, por favor intente nuevamente.',
  //   })
  // }

  return (
    <div className="dashboard-migrants row">
      {/* <button onClick={handleClick}>dd</button> */}
      <div className="col-12">
        <MigrantsHeader
          user={user}
          dispatch={dispatch}
          setView={setView}
          showContact={user?.logged && user?.role === 16}
        />
      </div>
      {!user?.logged ? (
        <>
          <div className="col-12">
            <MigrantsBanner
              showButton={user?.role !== 16}
              path={!user?.logged ? '/login' : '/dashboard'}
            />
          </div>
          <div className="col-12">
            <MigrantsVideo />
          </div>
        </>
      ) : (
        <>
          {user?.role === 16 && (
            <>
              {view === 1 && (
                <div className="col-12">
                  <MigrantsProcess />
                </div>
              )}
            </>
          )}
        </>
      )}
      <div className="col-12">
        <MigrantsFooter />
      </div>
    </div>
  )
}

export default DashboardMigrants
